export const ORDERLINE_TIMELINE_STEP_TYPE = {
  delivery: 'delivery',
  payment: 'payment',
  shipment: 'shipment',
  validation: 'validation',
  prepared: 'prepared',
} as const

export type StepType =
  (typeof ORDERLINE_TIMELINE_STEP_TYPE)[keyof typeof ORDERLINE_TIMELINE_STEP_TYPE]

export type OrderlineTimelineStep = {
  type: StepType | null
  date: string | null
  dateRange?: {
    minDate: string
    maxDate: string
    maxDateDetails: string
  }
  current: boolean
  label: string
  hint: string | null
  details: string | null
}
